module.exports = __webpack_public_path__ + "static/media/play-stone-player-active.6f7c47f8.png";